let language = {
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_PRICE: "价格:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ITEM_TOTAL: "总计:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_HEADER_ORDER_NUMBER: "订单",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_HEADER_QTY: "数量",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_HEADER_TOTAL_PRICE: "总价",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_HEADER_STORE_NAME: "店铺",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_HEADER_UNIT_PRICE: "单价:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_SUBTOTAL: "小计:",

    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_TITLE: "总价详情",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_UNIT_PRICE: "单价详情",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_ORIGINAL_PRICE: "原价:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_COMBINE_DISCOUNT: "拼单折扣:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_COUPON_DISCOUNT: "优惠券折扣:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_DISCOUNTED_PRICE: "折后价:",
};

export { language }
